import { SeatMapsInt, SeatmapCollectionInt } from "@app/interfaces";

export class SeatMapsMapper {

  private static seatMaps: SeatMapsInt[];

  constructor() { }

  static getSeatMaps(res: SeatmapCollectionInt): SeatMapsInt[] {
    this.seatMaps = [];
    let seatRes = [];

    if (res && res.seatMap && res.seatMap.length > 0) {
      this.seatMaps = res?.seatMap;

      if (!this.seatMaps || !this.seatMaps[0]?.seatSummary || !this.seatMaps[0]?.sections) {
        return [];
      }

      seatRes = this.parseJson(this.seatMaps);
    }

    return seatRes;
  }

  private static parseJson(seatJson) {
    let seatMaps = [];
    let legs = seatJson;
    let seatC:any
    for (let index = 0; index < legs.length; index++) {
      this.parseLeg(legs[index], index, seatMaps);
      seatC = seatMaps
    }
    return seatC;
  }

  private static parseLeg(leg, legIndex, seatMaps) {
    let seatMap = {};
    let sectionInfo = [];
    let sections = leg.sections;
    seatMaps[legIndex] = {
      segment: leg.segment,
      seatMap: seatMap,
      sectionInfo: this.parseSectionInfo(sections),
      seatSummary: leg.seatSummary,
      seatSelectionFee: leg.seatSelectionFee,
      status: leg.status,
      seatDistributionCollection:leg.seatDistributionCollection
    };
    for (let index = 0; index < sections.length; index++) {
      this.parseSection(sections[index], seatMap, sectionInfo,index, seatMaps[legIndex]);
    }
  }

  private static parseSection(section, seatMap, sectionInfo,index, seatMapInfo) {
    let sectionCode = this.convertSectionCode(section);
     sectionInfo[index] = section;
    let rows = section.rows;

    for (let index = 0; index < rows.length; index++) {
      let isFirstRowOfSection = (index == 0);
      this.parseRow(rows[index], sectionCode, seatMap, isFirstRowOfSection, seatMapInfo);
    }
  }

  private static parseRow(row, sectionCode, seatMap, isFirstRowOfSection, seatMapInfo) {
    let seats = row.seats;

    for (let index = 0; index < seats.length; index++) {
      this.parseSeat(seats[index], sectionCode, seatMap, isFirstRowOfSection,seatMapInfo);
    }
  }

  private static parseSectionInfo(sections) {
    if (!sections || sections.length === 0) {
      return [];
    }
    const seatTypes = this.extractSeatTypesFromSections(sections);

    return this.organizeBySeatType(sections, seatTypes);
  }

  private static extractSeatTypesFromSections(sections) {
    let seatTypes = new Set();

    for (const section of sections) {
      if (section.rows && section.rows.length > 0) {
        for (const row of section.rows) {
          if (row.seats && row.seats.length > 0) {
            seatTypes.add(row.seats[0].seatType);
          }
        }
      }
    }
    
    return Array.from(seatTypes);
  }

  private static organizeBySeatType(sections, seatTypes) {
    const organizedSections = [];
    
    for (const seatType of seatTypes) {
      const section = {
        code: seatType,
        rows: this.getRowsForSeatType(sections, seatType)
      };

      organizedSections.push(section);
    }

    return organizedSections;
  }

  private static getRowsForSeatType(sections, seatType) {
    const rows = [];

    for (const section of sections) {
      if (section.rows && section.rows.length > 0) {
        for (const row of section.rows) {
          if (row.seats && row.seats.length > 0 && row.seats[0].seatType === seatType) {
            const rowClone = row;

            rowClone.seats = rowClone.seats.filter((seat) => seat.seatType === seatType);
            rows.push(rowClone);
          }
        }
      }
    }

    return rows;
  }

  private static parseSeat(seat, sectionCode, seatMap, setSectionInfo , seatMapInfo) {
    let seatId = seat.code;
    seatMap[seatId] = seat;
    seat.seatId = seatId;
    seat.section = sectionCode;
    seat.assigned = false;
    seat.currentAssigned = false;
    
    if (seat.currency) {
      seat.cost = seat.currency.base;
    }
    else if ( seat.choice.subjectToSeatSelectionFee) {
      seat.cost = seatMapInfo.seatSelectionFee.total;
    } else {
      seat.cost = 0;
    }

    if (setSectionInfo)
      seat.sectionInfo = sectionCode;
    else
      seat.sectionInfo = null;
  }

  private static convertSectionCode(section) {
    switch (section.code) {
      case "FIRST_CLASS":
        section.name = 'Premiere Class';
        section.class = 'firstClass';
        return 1;
      case "AM_PLUS":
        section.name = 'AM Plus';
        section.class = 'amPlus';
        return 2;
      case "PREFERRED":
      case "EXIT_ROW":
        section.name = 'Preferred Seating';
        section.class = 'amPreferred';
        return 3;
      case "COACH":
        section.name = 'Coach';
        section.class = 'coach';
        return 4;
      default:
        return -1;
    }
  }
}
